var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80135 1.31261C7.99262 1.22913 8.21002 1.22913 8.4013 1.3126L14.3 3.8866C14.5733 4.00587 14.75 4.27577 14.75 4.574V6.66667C14.75 7.08088 14.4142 7.41667 14 7.41667H2C1.58579 7.41667 1.25 7.08088 1.25 6.66667V4.66267C1.25 4.36444 1.42669 4.09456 1.70002 3.97527L7.80135 1.31261ZM8.10135 2.8183L2.75 5.15367V5.91667H13.25V5.06502L8.10135 2.8183Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76221 5.91675C10.1764 5.91675 10.5122 6.25253 10.5122 6.66675V12.0001C10.5122 12.4143 10.1764 12.7501 9.76221 12.7501C9.34799 12.7501 9.01221 12.4143 9.01221 12.0001V6.66675C9.01221 6.25253 9.34799 5.91675 9.76221 5.91675Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6665 5.91675C13.0807 5.91675 13.4165 6.25253 13.4165 6.66675V12.0001C13.4165 12.4143 13.0807 12.7501 12.6665 12.7501C12.2523 12.7501 11.9165 12.4143 11.9165 12.0001V6.66675C11.9165 6.25253 12.2523 5.91675 12.6665 5.91675Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76221 5.91675C10.1764 5.91675 10.5122 6.25253 10.5122 6.66675V12.0001C10.5122 12.4143 10.1764 12.7501 9.76221 12.7501C9.34799 12.7501 9.01221 12.4143 9.01221 12.0001V6.66675C9.01221 6.25253 9.34799 5.91675 9.76221 5.91675Z",
    className: "icon-fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6665 5.91675C13.0807 5.91675 13.4165 6.25253 13.4165 6.66675V12.0001C13.4165 12.4143 13.0807 12.7501 12.6665 12.7501C12.2523 12.7501 11.9165 12.4143 11.9165 12.0001V6.66675C11.9165 6.25253 12.2523 5.91675 12.6665 5.91675Z",
    className: "icon-fill"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 5.91675C3.74771 5.91675 4.0835 6.25253 4.0835 6.66675V12.0001C4.0835 12.4143 3.74771 12.7501 3.3335 12.7501C2.91928 12.7501 2.5835 12.4143 2.5835 12.0001V6.66675C2.5835 6.25253 2.91928 5.91675 3.3335 5.91675Z",
    className: "icon-fill"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23779 5.91675C6.65201 5.91675 6.98779 6.25253 6.98779 6.66675V12.0001C6.98779 12.4143 6.65201 12.7501 6.23779 12.7501C5.82358 12.7501 5.48779 12.4143 5.48779 12.0001V6.66675C5.48779 6.25253 5.82358 5.91675 6.23779 5.91675Z",
    className: "icon-fill"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 5.91675C3.74771 5.91675 4.0835 6.25253 4.0835 6.66675V12.0001C4.0835 12.4143 3.74771 12.7501 3.3335 12.7501C2.91928 12.7501 2.5835 12.4143 2.5835 12.0001V6.66675C2.5835 6.25253 2.91928 5.91675 3.3335 5.91675Z",
    className: "icon-fill"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23779 5.91675C6.65201 5.91675 6.98779 6.25253 6.98779 6.66675V12.0001C6.98779 12.4143 6.65201 12.7501 6.23779 12.7501C5.82358 12.7501 5.48779 12.4143 5.48779 12.0001V6.66675C5.48779 6.25253 5.82358 5.91675 6.23779 5.91675Z",
    className: "icon-fill"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99585 11.6646C2.12289 11.4105 2.38259 11.25 2.66667 11.25H13.3333C13.6174 11.25 13.8771 11.4105 14.0042 11.6646L14.6708 12.9979C14.7229 13.1021 14.75 13.2169 14.75 13.3333V14C14.75 14.4142 14.4142 14.75 14 14.75H2C1.58579 14.75 1.25 14.4142 1.25 14V13.3333C1.25 13.2169 1.27711 13.1021 1.32918 12.9979L1.99585 11.6646ZM3.13019 12.75L2.88019 13.25H13.1198L12.8698 12.75H3.13019Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank);
export default __webpack_public_path__ + "static/media/icon-bank.0ba1902f7f2d65f091cd2f8b59e46294.svg";
export { ForwardRef as ReactComponent };